import * as React from 'react'
const SvgComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={168}
    height={147}
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    shapeRendering="geometricPrecision"
    vectorEffect="non-scaling-stroke"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M120.31 71.52h17.3a8.949 8.949 0 0 0 8.95-8.95V48.959M39.907 73.98H22.816c-5.514 0-9.98 4.472-9.98 9.98v12.99"
    />
    <path
      fill="#fff"
      d="m160.123 17.984-17.406-9.949a1.272 1.272 0 0 0-1.369.056l-6.439 3.676 5.816 10.312-.055 11.916c0 .469.252.9.659 1.135l8.475 4.755 4.188 9.055 6.575-3.732s.012-.006.018-.012l.037-.019a1.27 1.27 0 0 0 .599-1.085l.111-24.011c0-.864-.457-1.665-1.209-2.091"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m160.123 17.984-17.406-9.949a1.272 1.272 0 0 0-1.369.056l-6.439 3.676 5.816 10.312-.055 11.916c0 .469.252.9.659 1.135l8.475 4.755 4.188 9.055 6.575-3.732s.012-.006.018-.012l.037-.019a1.27 1.27 0 0 0 .599-1.085l.111-24.011c0-.864-.457-1.665-1.209-2.091v-.006Z"
    />
    <path
      fill="#fff"
      d="m134.366 12.828-.111 24.843c0 .469.253.9.66 1.135l17.967 10.078a1.293 1.293 0 0 0 1.924-1.122l.111-24.011c0-.864-.456-1.666-1.209-2.091l-17.405-9.949a1.288 1.288 0 0 0-1.931 1.117"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m134.366 12.828-.111 24.843c0 .469.253.9.66 1.135l17.967 10.078a1.293 1.293 0 0 0 1.924-1.122l.111-24.011c0-.864-.456-1.666-1.209-2.091l-17.405-9.949a1.288 1.288 0 0 0-1.931 1.117h-.006Z"
    />
    <path
      fill="#fff"
      d="M150.051 28.284c1.961 4.379 1.067 9.042-2.005 10.417-3.071 1.376-7.148-1.054-9.116-5.434-1.961-4.379-1.067-9.041 2.005-10.417 3.071-1.375 7.148 1.055 9.116 5.434Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M150.051 28.284c1.961 4.379 1.067 9.042-2.005 10.417-3.071 1.376-7.148-1.054-9.116-5.434-1.961-4.379-1.067-9.041 2.005-10.417 3.071-1.375 7.148 1.055 9.116 5.434Z"
    />
    <path
      fill="#fff"
      d="M154.633 19.674c1.141 0 2.06-.938 2.054-2.073l-.049-7.938c-.006-1.88.586-3.41 1.511-3.898 1.363-.709 2.8-.832 3.664-.314.962.58 1.172 1.973 1.178 3.034l.031.882a2.06 2.06 0 0 0 2.072 2.054c1.141 0 2.06-.931 2.054-2.072l-.031-.882c-.018-4.046-1.998-5.841-3.17-6.557-2.134-1.289-5.015-1.215-7.71.185-2.356 1.228-3.75 4.059-3.731 7.58l.049 7.938a2.06 2.06 0 0 0 2.072 2.055"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M154.633 19.674c1.141 0 2.06-.938 2.054-2.073l-.049-7.938c-.006-1.88.586-3.41 1.511-3.898 1.363-.709 2.8-.832 3.664-.314.962.58 1.172 1.973 1.178 3.034l.031.882a2.06 2.06 0 0 0 2.072 2.054c1.141 0 2.06-.931 2.054-2.072l-.031-.882c-.018-4.046-1.998-5.841-3.17-6.557-2.134-1.289-5.015-1.215-7.71.185-2.356 1.228-3.75 4.059-3.731 7.58l.049 7.938a2.06 2.06 0 0 0 2.072 2.055l.006.006Z"
    />
    <path
      fill="#fff"
      d="M146.036 30.615c0-.919-.901-2.109-1.974-2.553-.839-.346-1.511-.08-1.579.629-.056.605.321 1.357.9 1.937l-.012 2.25c0 .223.204.5.456.63l.827.42c.253.129.456.055.456-.167l.013-2.251c.542.012.913-.309.919-.895"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M146.036 30.615c0-.919-.901-2.109-1.974-2.553-.839-.346-1.511-.08-1.579.629-.056.605.321 1.357.9 1.937l-.012 2.25c0 .223.204.5.456.63l.827.42c.253.129.456.055.456-.167l.013-2.251c.542.012.913-.309.919-.895h-.006Z"
    />
    <g opacity={0.2}>
      <mask
        id="a"
        width={6}
        height={3}
        x={140}
        y={11}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M145.536 11.063h-4.614v2.412h4.614v-2.412Z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#000"
          d="M145.536 12.266c0 .666-1.036 1.203-2.307 1.203-1.27 0-2.307-.543-2.307-1.203s1.037-1.203 2.307-1.203c1.271 0 2.307.543 2.307 1.203Z"
        />
      </g>
    </g>
    <g opacity={0.1}>
      <mask
        id="b"
        width={9}
        height={8}
        x={153}
        y={17}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M161.264 17.626h-7.574v7.025h7.574v-7.025Z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#000"
          d="m159.635 17.626-5.945 3.744s.728.826 1.128 1.745c.29.66.05 1.536.05 1.536l6.396-3.738s-.037-1.671-.586-2.313c-.549-.64-1.043-.968-1.043-.968"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="M126.687 96.802v21.309a2.867 2.867 0 0 1-1.412 2.227l-31.308 18.226a6.78 6.78 0 0 1-6.772 0L57.01 121.059c-1.345-.882-1.166-2.572-1.166-3.898V97.289"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M126.687 96.802v21.309a2.867 2.867 0 0 1-1.412 2.227l-31.308 18.226a6.78 6.78 0 0 1-6.772 0L57.01 121.059c-1.345-.882-1.166-2.572-1.166-3.898V97.289"
    />
    <path
      fill="#fff"
      d="m95.349 76.874 29.988 17.418c1.794 1.036 1.794 3.632 0 4.668l-31.382 18.091a6.78 6.78 0 0 1-6.772 0L57.195 99.633c-1.795-1.036-1.795-3.633 0-4.67l31.382-18.09a6.776 6.776 0 0 1 6.772 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m95.349 76.874 29.988 17.418c1.794 1.036 1.794 3.632 0 4.668l-31.382 18.091a6.78 6.78 0 0 1-6.772 0L57.195 99.633c-1.795-1.036-1.795-3.633 0-4.67l31.382-18.09a6.776 6.776 0 0 1 6.772 0Z"
    />
    <path
      fill="#fff"
      d="m78.986 116.144-6.624 6.883c-.303.345-.876.567-1.271.339L60.6 117.1a.58.58 0 0 1-.142-.888l6.001-6.298a1.394 1.394 0 0 1 1.727-.234l10.806 6.47-.006-.006Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m78.986 116.144-6.624 6.883c-.303.345-.876.567-1.271.339L60.6 117.1a.58.58 0 0 1-.142-.888l6.001-6.298a1.394 1.394 0 0 1 1.727-.234l10.806 6.47-.006-.006ZM78.986 116.144v17.448M67.415 121.3v5.662"
    />
    <path
      className="gray-element"
      fill="currentColor"
      d="M115.474 61.522v21.31a2.866 2.866 0 0 1-1.412 2.226l-31.308 18.226a6.776 6.776 0 0 1-6.772 0L45.797 85.78c-1.338-.882-1.166-2.572-1.166-3.898V62.009"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M115.474 61.522v21.31a2.866 2.866 0 0 1-1.412 2.226l-31.308 18.226a6.776 6.776 0 0 1-6.772 0L45.797 85.78c-1.338-.882-1.166-2.572-1.166-3.898V62.009"
    />
    <path
      className="gray-element"
      fill="currentColor"
      d="m84.136 41.594 29.988 17.418c1.794 1.036 1.794 3.633 0 4.669L82.742 81.77a6.776 6.776 0 0 1-6.772 0L45.982 64.353c-1.795-1.036-1.795-3.633 0-4.669l31.382-18.09a6.776 6.776 0 0 1 6.772 0Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m84.136 41.594 29.988 17.418c1.794 1.036 1.794 3.633 0 4.669L82.742 81.77a6.776 6.776 0 0 1-6.772 0L45.982 64.353c-1.795-1.036-1.795-3.633 0-4.669l31.382-18.09a6.776 6.776 0 0 1 6.772 0Z"
    />
    <path
      fill="#fff"
      d="M103.558 26.785v21.347a2.866 2.866 0 0 1-1.412 2.226L70.838 68.584a6.776 6.776 0 0 1-6.772 0L33.88 51.08c-1.339-.882-1.166-2.572-1.166-3.898V27.266"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M103.558 26.785v21.347a2.866 2.866 0 0 1-1.412 2.226L70.838 68.584a6.776 6.776 0 0 1-6.772 0L33.88 51.08c-1.339-.882-1.166-2.572-1.166-3.898V27.266"
    />
    <path
      fill="#fff"
      d="m72.22 6.863 29.987 17.418c1.795 1.036 1.795 3.633 0 4.669L70.826 47.04a6.776 6.776 0 0 1-6.772 0L34.066 29.622c-1.795-1.036-1.795-3.633 0-4.669l31.382-18.09a6.776 6.776 0 0 1 6.772 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m72.22 6.863 29.987 17.418c1.795 1.036 1.795 3.633 0 4.669L70.826 47.04a6.776 6.776 0 0 1-6.772 0L34.066 29.622c-1.795-1.036-1.795-3.633 0-4.669l31.382-18.09a6.776 6.776 0 0 1 6.772 0Z"
    />
    <path
      fill="#fff"
      d="M67.446 45.782a4.624 4.624 0 0 1-2.3-.617L35.156 27.747a.51.51 0 0 1-.265-.456.51.51 0 0 1 .265-.457L66.54 8.744a4.64 4.64 0 0 1 2.3-.616c.802 0 1.604.216 2.301.616l29.988 17.418a.51.51 0 0 1 .265.457.498.498 0 0 1-.265.456l-31.382 18.09c-.697.401-1.492.617-2.3.617Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="M67.446 45.782a4.624 4.624 0 0 1-2.3-.617L35.156 27.747a.51.51 0 0 1-.265-.456.51.51 0 0 1 .265-.457L66.54 8.744a4.64 4.64 0 0 1 2.3-.616c.802 0 1.604.216 2.301.616l29.988 17.418a.51.51 0 0 1 .265.457.498.498 0 0 1-.265.456l-31.382 18.09c-.697.401-1.492.617-2.3.617Z"
    />
    <path
      fill="#fff"
      d="m35.343 27.852 31.19-17.985a4.561 4.561 0 0 1 2.3-.617c.809 0 1.604.21 2.301.617l29.803 17.313"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m35.343 27.852 31.19-17.985a4.561 4.561 0 0 1 2.3-.617c.809 0 1.604.21 2.301.617l29.803 17.313"
    />
    <path
      fill="#fff"
      d="m87.534 23.707 3.91 2.227a.938.938 0 0 1 0 1.628l-3.891 2.307c-.728.42-1.635.42-2.362 0l-3.695-2.227a.938.938 0 0 1 0-1.628l3.676-2.307a2.375 2.375 0 0 1 2.362 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      strokeWidth={0.5}
      d="m87.534 23.707 3.91 2.227a.938.938 0 0 1 0 1.628l-3.891 2.307c-.728.42-1.635.42-2.362 0l-3.695-2.227a.938.938 0 0 1 0-1.628l3.676-2.307a2.375 2.375 0 0 1 2.362 0Z"
    />
    <g opacity={0.15}>
      <mask
        id="c"
        width={7}
        height={23}
        x={64}
        y={47}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M70.604 47.176H64.54V69.59h6.063V47.176Z" />
      </mask>
      <g mask="url(#c)">
        <path
          fill="#000"
          d="M64.652 47.182c-.24-.191 0 21.674 0 21.674s2.282 1.653 5.952 0V47.182s-3.553 1.894-5.952 0Z"
        />
      </g>
    </g>
    <g opacity={0.15}>
      <mask
        id="d"
        width={7}
        height={24}
        x={76}
        y={81}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M82.908 81.906h-6.056v22.414h6.056V81.907Z" />
      </mask>
      <g mask="url(#d)">
        <path
          fill="#fff"
          d="M76.957 81.913c-.241-.192 0 21.673 0 21.673s2.282 1.653 5.951 0V81.913s-3.552 1.893-5.951 0Z"
        />
      </g>
    </g>
    <g opacity={0.15}>
      <mask
        id="e"
        width={7}
        height={23}
        x={87}
        y={117}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M93.85 117.051h-6.063v22.407h6.063v-22.407Z" />
      </mask>
      <g mask="url(#e)">
        <path
          fill="#000"
          d="M87.898 117.051c-.24-.192 0 21.673 0 21.673s2.282 1.653 5.952 0v-21.673s-3.553 1.893-5.952 0Z"
        />
      </g>
    </g>
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M9.284 119.518s2.726 2.763 7.654 2.035a.892.892 0 0 1 1.018.734c.061.37.08.641.086.82a.616.616 0 0 0 .222.457l3.96 3.287c2.041 1.326 3.417 3.503 3.639 5.927.018.179.024.333.024.463l.475 9.356a2.786 2.786 0 0 1-1.53 2.597 7.59 7.59 0 0 1-7.45-.345l-13.736-8.604a5.063 5.063 0 0 1-2.356-3.985c-.13-2.14-.271-1.338-.42-3.953-.419-7.513 6.28-8.037 8.007-8.049.222 0 .4-.185.4-.407v-1.043"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.75}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M9.284 119.518s2.726 2.763 7.654 2.035a.892.892 0 0 1 1.018.734c.061.37.08.641.086.82a.616.616 0 0 0 .222.457l3.96 3.287c2.041 1.326 3.417 3.503 3.639 5.927.018.179.024.333.024.463l.475 9.356a2.786 2.786 0 0 1-1.53 2.597 7.59 7.59 0 0 1-7.45-.345l-13.736-8.604a5.063 5.063 0 0 1-2.356-3.985c-.13-2.14-.271-1.338-.42-3.953-.419-7.513 6.28-8.037 8.007-8.049.222 0 .4-.185.4-.407v-1.043"
    />
    <path
      className="gray-element"
      fill="currentColor"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M8.6 103.895c3.003-1.838 10.133-1.764 11.73.9 1.357 2.258-2.547 2.905-2.498 4.392.148 4.391.013 3.972.05 4.539a1.251 1.251 0 0 1-.956 1.295l-.192-.493s-.549-.697-1.548-.352c-.857.303-.666 1.234-.394 1.857.265.611.172 1.314-.266 1.807l-.172.191a4.436 4.436 0 0 1-4.484 1.326l-.882-.24-3.041-5.434c-1.745-4.546-.358-7.944 2.646-9.782"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M16.593 119.554s4.089.099 4.286-3.632c.191-3.726-1.14-9.246-1.14-9.246M17.413 119.585v1.888M17.666 136.152c0 .191.61 9.184.61 9.184"
    />
    <path
      className="gray-element"
      fill="currentColor"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M12.793 118.525c0 2.621-2.288 4.743-5.119 4.743s-5.12-2.122-5.12-4.743c0-2.622 2.289-4.744 5.12-4.744s5.12 2.122 5.12 4.744Z"
    />
  </svg>
)
export default SvgComponent
